import type { Translate } from 'next-translate';
import React from 'react';
import { Button } from '@/components/UI';
import styles from './PricingCta.module.scss';

interface Props {
	t: Translate;
	disabled?: boolean;
	onClick: () => void;
}

/** Plan CTA — rendered inside the offer card on desktop and as the fixed bar on phones */
export const PricingCta: React.FC<Props> = ({ t, disabled, onClick }) => (
	<Button
		as='button'
		preset='primary'
		size='large'
		fullWidth
		disabled={disabled}
		// Same label for both variants, so the two paywall flavors stay consistent
		text={t('plansDefault_button')}
		classes={{ button: styles['cta'] }}
		onClick={onClick}
	/>
);
